import { toast } from 'react-hot-toast';
import ErrorExclamationTriangle from '../assets/icons/ErrorExclamationTriangle.esm.js';
import InfoCircle from '../assets/icons/InfoCircle.esm.js';
import SuccessCheckCircle from '../assets/icons/SuccessCheckCircle.esm.js';
import WarningExclamantionCircle from '../assets/icons/WarningExclamationCircle.esm.js';

var _a;
var TYPE;
(function (TYPE) {
    TYPE["SUCCESS"] = "success";
    TYPE["ERROR"] = "error";
    TYPE["INFO"] = "info";
    TYPE["WARNING"] = "warning";
})(TYPE || (TYPE = {}));
var ICON_MAP = (_a = {},
    _a[TYPE.SUCCESS] = SuccessCheckCircle(),
    _a[TYPE.ERROR] = ErrorExclamationTriangle(),
    _a[TYPE.INFO] = InfoCircle(),
    _a[TYPE.WARNING] = WarningExclamantionCircle(),
    _a);
var parsePayload = function (payload) {
    if (Object.prototype.hasOwnProperty.call(payload, 'message')) {
        return payload;
    }
    return { message: payload };
};
var showToastByType = function (type, payload) {
    var _a = parsePayload(payload), closeTimeout = _a.closeTimeout, message = _a.message, position = _a.position, toastId = _a.toastId;
    toast(message, {
        className: "nv-notification--".concat(type),
        duration: closeTimeout,
        icon: ICON_MAP[type],
        id: toastId,
        position: position,
    });
};
var success = function (payload) { return showToastByType(TYPE.SUCCESS, payload); };
var error = function (payload) { return showToastByType(TYPE.ERROR, payload); };
var warning = function (payload) { return showToastByType(TYPE.WARNING, payload); };
var info = function (payload) { return showToastByType(TYPE.INFO, payload); };
var dismiss = function () { return toast.dismiss(); };
var showToast = { dismiss: dismiss, error: error, info: info, success: success, warning: warning };

export { showToast };
//# sourceMappingURL=showToast.esm.js.map
